import { Chip, Tooltip } from '@mui/material';
import { ALLOCATION_SOURCE } from '../../../lib/packingListAllocation';

const COLOR = { auto_single: '#2e7d32', auto_pl: '#00647e' };

/** 배분이 자동(컨테이너 1대·PL 번호)인지 사람이 한 것인지. 자동 배분만 색으로 구분한다. */
export default function AllocationSourceBadge({ source }) {
    const meta = ALLOCATION_SOURCE[source] ?? ALLOCATION_SOURCE.manual;
    const color = COLOR[source];
    return (
        <Tooltip title={meta.title} arrow>
            <Chip
                size="small"
                label={meta.label}
                variant={color ? 'filled' : 'outlined'}
                sx={{ fontSize: 9, height: 16, '& .MuiChip-label': { px: 0.75 }, ...(color ? { bgcolor: color, color: 'white' } : {}) }}
            />
        </Tooltip>
    );
}
